import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Seo } from "@/components/site/Seo";
import { api } from "@/lib/api";
import { SITE } from "@/lib/site";
import { BookingsTab } from "./BookingsTab";
import { RoutesTab } from "./RoutesTab";
import { InquiriesTab, MessagesTab } from "./InquiriesTab";

const TABS = [
  ["bookings", "Bookings", BookingsTab],
  ["prices", "Price table", RoutesTab],
  ["inquiries", "Tour inquiries", InquiriesTab],
  ["messages", "Messages", MessagesTab],
];

export default function AdminDashboard() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => navigate("/admin/login", { replace: true }));
  }, [navigate]);

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    navigate("/admin/login");
  };

  if (!user) return <div className="flex min-h-screen items-center justify-center text-slate-500" data-testid="admin-loading">Loading…</div>;

  return (
    <div className="min-h-screen bg-silver/50" data-testid="admin-dashboard">
      <Seo title="Owner dashboard" description="Alpha Transfer owner dashboard." noindex />
      <header className="border-b border-slate-200 bg-white">
        <div className="container-x flex h-16 items-center justify-between">
          <Link to="/" data-testid="admin-home-link"><img src={SITE.logoDark} alt="Alpha Transfer logo" className="h-8 w-auto" /></Link>
          <div className="flex items-center gap-4 text-sm">
            <span className="hidden text-slate-500 sm:inline">{user.email}</span>
            <button onClick={logout} className="btn btn-outline min-h-[38px] px-4" data-testid="admin-logout-button"><LogOut className="h-4 w-4" /> Log out</button>
          </div>
        </div>
      </header>
      <main className="container-x py-10">
        <h1 className="font-serif text-4xl text-ink">Dashboard</h1>
        <Tabs defaultValue="bookings" className="mt-8">
          <TabsList className="h-auto flex-wrap justify-start gap-1 rounded-full bg-white p-1">
            {TABS.map(([v, l]) => (
              <TabsTrigger key={v} value={v} className="rounded-full px-5 py-2 data-[state=active]:bg-ink data-[state=active]:text-white" data-testid={`admin-tab-${v}`}>{l}</TabsTrigger>
            ))}
          </TabsList>
          {TABS.map(([v, , C]) => (
            <TabsContent key={v} value={v} className="mt-6"><C /></TabsContent>
          ))}
        </Tabs>
      </main>
    </div>
  );
}
